<template>
  <div id="platform-overview" class="default-layout">

    <header>
      <!-- <Navbar/> -->
      <nav id="navbar">
          <div class="nav">
              <router-link to="/home" class="nav-item">Back</router-link>
              <router-link to="/home" class="nav-item">Home</router-link>
          </div>
          <div class="logo">
              <img src="@/assets/images/navbar-logo.svg" alt=""/>
          </div>
      </nav>
    </header>
    
    <main>
      <div class="page-header">
        <p class="eyebrow">Working Together</p>
        <h1>SmartAC.com <br/> Partnership</h1>
      </div>

        <section id="alert-generation">
            <div class="content">
                <img src="@/assets/images/alert-generation-flow.png" alt="">
                <h2 class="mt-12">Alert generation</h2>
                <p class="is-large">We offer a unique, low cost interaction platform that gathers sensor data every 10 seconds, 24/7 and transfers to the cloud where potential issues are analyzed in our verification process.</p>
                <p class="is-large">Verified issues are captured and sent to your dashboard to review and discuss with your client.</p>
            </div>
        </section>

        <section>
            <ul class="bullet-list">
            <li><img src="@/assets/images/list-item-bullet.png" alt="" class="bullet">Sell based on data</li>
            <li><img src="@/assets/images/list-item-bullet.png" alt="" class="bullet">Early AC failure</li>
            <li><img src="@/assets/images/list-item-bullet.png" alt="" class="bullet">Increase customer acquisition</li>
            <li><img src="@/assets/images/list-item-bullet.png" alt="" class="bullet">Increase customer retention</li>
            <li><img src="@/assets/images/list-item-bullet.png" alt="" class="bullet">Reduce expensive truck rolls</li>
            <li><img src="@/assets/images/list-item-bullet.png" alt="" class="bullet">In-portal service requests</li>
            </ul>
        </section>

        <section id="business-cases">
            <h1 class="display-1">Business use cases</h1>

            <div class="business-case">
                <p class="eyebrow">Use case one</p>
                <h2 class="case-name">Premium Maintenance Plan</h2>
                <p class="case-description">Take your customer service to another level by including 24/7/365 HVAC health monitoring with your service plans. Your customers can track air filters and system health in-between tuneups.</p>
            </div>

            <div class="business-case">
                <p class="eyebrow">Use case two</p>
                <h2 class="case-name">Smart (Virtual) Maintenance</h2>
                <p class="case-description">Monitor performance 24/7/365 and only roll a truck when you know there’s revenue to be had. A lower priced offer will dramatically increase the percent of your customers who say “yes” to a maintenance plan.</p>
            </div>

            <div class="business-case">
                <p class="eyebrow">Use case three</p>
                <h2 class="case-name">“Whole Home” HVAC/Plumbing Offer</h2>
                <p class="case-description">With cost effective water sensors added to the SmartAC.com kit, you can monitor HVAC performance and leak detection all from a remote dashboard. Package these together to stake your claim in every home.</p>
            </div>
        </section>

        <section class="feature-callout">
          <div class="col">
            <h2>Platform overview</h2>
            <p>Transparent customer HVAC data in our dashboard.</p>
            <router-link to="/platform-overview" class="button is-primary uppercase is-large mt4">Learn more</router-link>
          </div>
          <div class="col">
            <img src="@/assets/images/noc-dashboard-thumbnail.jpg" alt="">
          </div>
        </section>

    </main>

    <Footer/>
    
  </div>
</template>

<style lang="scss" scoped>

#alert-generation {
    padding: 0;
    background: linear-gradient(180deg, rgba(20, 33, 69, 0) 0%, #142145 87.5%);

    & .content {
        padding: 64px;
    }
}

#business-cases {
    display: flex;
    flex-direction: column;
    border-top: 8px dotted #142145;

    & .business-case {
        display: flex;
        flex-direction: column;
        margin-top: 4rem;
    }
}

</style>

<script>
    import Footer from '@/components/Footer.vue'
    
    export default {
        components: {
            Footer
        }
    }
</script>